<template>
    <div class="cooperation_container">
      <q-dialog
        v-model="customDialogModel"
        stack-buttons
        prevent-close
      >
        <div class="dialog_main">
            <div class="form_content" v-if="submitSuccess">
                <h2>{{lang.coop}}</h2>
                <div class="form_items">
                    <div class="form_item m_r_72">
                        <label>{{lang.coopBusiness}}</label>
                        <div class="form_select" @click="seletItems">
                            <p>{{businessNames}}</p>
                            <span class="icon"><img :src="isShowSelect ? selectDown : selectUp" alt=""></span>
                        </div>
                        <div class="form_select_content" v-if="isShowSelect">
                            <p v-for='(item, index) in selectList' :key='index' @click="selectForm(index)">
                                <img :src="item.status ? selectCheck : selectBorder" alt="">
                                <span :class="item.status ? 'active' : ''"> {{item.name}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="form_item m_r_72">
                        <label>{{lang.coopCompany}}</label>
                        <input type="text" v-model="company" maxlength="100">
                    </div>
                    <div class="form_item">
                        <label>{{lang.coopCity}}</label>
                        <input type="text" v-model="city" maxlength="50">
                    </div>
                    <div class="form_item m_t_72 m_r_72">
                        <label>{{lang.coopName}}</label>
                        <input type="text" v-model="name" maxlength="50">
                    </div>
                    <div class="form_item m_t_72 m_r_72">
                        <label>{{lang.coopPhone}}</label>
                        <input type="text" v-model="phone" maxlength="20">
                    </div>
                    <div class="form_item m_t_72">
                        <label>{{lang.coopEmail}}</label>
                        <input type="text" v-model="email" maxlength="50">
                    </div>
                </div>
                <div class="btn"><button @click="submit">{{lang.submit}}</button></div>
                <div class="close">
                    <img :src="closeBtn" alt="" @click="close">
                </div>
            </div>
            <div class="form_success_content" v-else>
                <h2>{{lang.coop}}</h2>
                <p>{{lang.coopSuccess}}</p>
                <div class="btn"><button @click="close">{{lang.ok}}</button></div>
                <div class="close">
                    <img :src="closeBtn" alt="" @click="close">
                </div>
            </div>
            <div class="select_dialog" v-if="isShowSelect"  @click="seletItems"></div>
        </div>
      </q-dialog>
    </div>
</template>

<script>
import ajax from '@/utils/ajax';
import validate from '@/utils/validate';
import getLang from '@/utils/main/language';
import selectBorder from '@/style/select_border.png';
import selectCheck from '@/style/select_check.png';
import selectUp from '@/style/select_up.png';
import selectDown from '@/style/select_down.png';
import closeBtn from '@/style/close_btn.png';

export default {
    name: 'home',
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            customDialogModel: false,
            isShowSelect: false,
            canSelect: true,
            selectList: [],
            selectBorder,
            selectCheck,
            selectUp,
            selectDown,
            closeBtn,
            businessNames: '',
            city: '',
            email: '',
            name: '',
            company: '',
            phone: '',
            submitSuccess: true,
            lang: getLang(),
        };
    },
    mounted() {
        const self = this;
        ajax.get('/web/business/business_list.json', {
            pageSize: 1000,
            page: 1,
        }).then((result) => {
            this.selectList = result.dataList.map((v) => {
                const name = self.isCn ? v.cnBusinessName : v.enBusinessName;
                return {
                    status: false,
                    name,
                };
            });
        }).catch(() => {});
    },

    methods: {
        seletItems() {
            if (this.canSelect) {
                this.isShowSelect = !this.isShowSelect;
            }
        },
        selectForm(index) {
            const item = this.selectList[index];
            item.status = !item.status;
            this.selectList[index] = item;
            const selectCheckArr = [];
            this.selectList.forEach((i) => {
                if (i.status) {
                    selectCheckArr.push(i.name);
                }
            });
            this.businessNames = selectCheckArr.join(' ');
        },
        submit() {
            if (validate.judge(this.businessNames, 'require') !== true) {
                this.$q.dialog({ title: this.lang.inputBusiness, message: '' });
            } else if (validate.judge(this.company, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputCompany, message: '' });
            } else if (validate.judge(this.city, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputBirthday, message: '' });
            } else if (validate.judge(this.name, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputName, message: '' });
            } else if (validate.judge(this.phone, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputPhone, message: '' });
            } else if (validate.judge(this.phone, ['number']) !== true) {
                this.$q.dialog({ title: this.lang.realPhone, message: '' });
            } else if (validate.judge(this.email, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputEmail, message: '' });
            } else {
                ajax.post('/web/common/partner_save.json', {
                    name: this.name,
                    phone: this.phone,
                    businessNames: this.businessNames,
                    company: this.company,
                    city: this.city,
                    email: this.email,
                }).then(() => {
                    this.submitSuccess = false;
                }).catch((info) => {
                    this.$q.dialog({ title: '', message: info.message });
                });
            }
        },
        openModel(business) {
            this.canSelect = !business;
            this.customDialogModel = true;
            this.submitSuccess = true;
            this.businessNames = business;
            this.city = '';
            this.email = '';
            this.name = '';
            this.company = '';
            this.phone = '';
        },
        close() {
            this.customDialogModel = false;
        },
    },
};
</script>
<style lang="less" scoped>
.cooperation_container{
    width: 100%;
    height: 100%;
    min-width: 1200px;
    position: relative;
}
.dialog_main {
    width: 100%;
    height: 480px;
    background: url(../style/dialog_bg.png) no-repeat #000;
    background-size: 100% 100%;
    max-width: 100%;
    border-radius: 0;
    min-width: 1200px;
    display: flex;
    justify-content: center;
    input, button{
        outline: none;
    }
    .select_dialog{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
.form_content{
    width: 828px;
    position: relative;
    h2{
        font-size:36px;
        text-align: center;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-top: 52px;
        margin-bottom: 30px;
    }
    .form_items{
        display: flex;
        flex-wrap: wrap;
        .m_t_72{
            margin-top: 72px;
        }
        .m_r_72{
            margin-right: 72px;
        }
    }
    .form_item{
        width: 228px;
        display: flex;
        flex-direction: column;
            position: relative;
        label{
            padding-left: 12px;
            border-left: 4px solid #C71F4B;
            margin-bottom: 4px;
            font-size:18px;
            font-weight:600;
            color:rgba(255,255,255,1);
        }
        input,.form_select{
            width:228px;
            height:42px;
            background:rgba(255,255,255,0.15);
            border:1px solid rgba(255,255,255,1);
            padding: 0 15px;
            color: #fff;
        }
        .form_select{
            position: relative;
            cursor: pointer;
            p{
                padding-right: 50px;
                line-height: 42px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .icon{
                position: absolute;
                top: 8px;
                right: 20px;
                width:9px;
                height:6px;
                img{
                    width:9px;
                    height:6px;
                }
            }
        }
        .form_select_content{
            width: 228px;
            height:200px;
            background:rgba(255,255,255,1);
            border:1px solid rgba(151,151,151,1);
            position: absolute;
            top: 100%;
            left: -1px;
            overflow-y: scroll;
            color: #4A4A4A;
            z-index: 99;
            p{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding:  5px 16px;
                font-weight:400;
                line-height: 18px;
                span {
                    display: inline-block;
                    max-width: 160px;
                    text-align: right;
                }
                img{
                    margin-top: 1px;
                    width: 16px;
                    height: 16px;
                }
                .active{
                    color: #C71F4B;
                }
            }
        }
    }
    .btn{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 64px;
        button{
            width:120px;
            height:36px;
            background:rgba(199,31,75,1);
            font-size:16px;
            font-weight:bold;
            color:rgba(255,255,255,1);
            cursor: pointer;
        }
    }
}
.form_success_content{
    width: 828px;
    position: relative;
    h2{
        font-size:36px;
        text-align: center;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-top: 56px;
    }
    p{
        font-size:18px;
        font-family:HelveticaNeue-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-top: 136px;
        text-align: center;
    }
    .btn{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 151px;
        button{
            width:120px;
            height:36px;
            background:rgba(199,31,75,1);
            font-size:16px;
            font-weight:bold;
            color:rgba(255,255,255,1);
            cursor: pointer;
        }
    }
}
.close{
    position: absolute;
    top: 18px;
    right: -66px;
    img{
        width: 32px;
        height: 32px;
    }
}
</style>
